const mensajes = {
    // CampoCodigoDocumentoBase
    'DocumentoBuscador.CampoCodigoDocumentoBase.Nombre': 'Base document code',
    'DocumentoBuscador.CampoIdentificacionCliente.Nombre':'Client identification',
    'DocumentoBuscador.CampoFactura.Factura':'Bill'
};

export default mensajes;
